<template lang="pug">
  .files
    .item(v-for="(file, fileId) in files")
      .image-container(v-if="isImage(file.path)")
        a(:href='file.url', target='_blank')
          img.image(:src="file.url")
      a.another(v-else, @click="download(file, fileId)")
        .description
          img.image(src="static/images/grey-16.jpg")
          .detail
            i.fa.fa-circle-o-notch.fa-spin(v-if="downloadIds[fileId]")
            i.fa(v-else, :class="getIcon(file.path)")
            .name {{ file.name }}
</template>

<script>
import FStorageImage from '@/components/FStorageImage'
import path from 'path'
export default {
  props: {
    files: {

    }
  },
  data () {
    return {
      downloadIds: {}
    }
  },
  components: {
    FStorageImage
  },
  methods: {
    isImage (filepath) {
      const ext = path.extname(filepath)
      return ['.jpg', '.png'].indexOf(ext) >= 0
    },
    getIcon (filepath) {
      const ext = path.extname(filepath)
      switch (ext) {
        case '.mp4': return 'fa-file-movie-o'
        case '.mov': return 'fa-file-movie-o'
        case '.pdf': return 'fa-file-pdf-o'
        case '.docx': return 'fa-file-word-o'
        case '.xlsx': return 'fa-file-excel-o'
        default: return 'fa-file-o'
      }
    },
    isVideo (filepath) {
      const ext = path.extname(filepath)
      return ['.mp4', '.mov'].indexOf(ext) >= 0
    },
    download (file, fileId) {
      this.$set(this.downloadIds, fileId, true)
      var link = document.createElement('a')
      link.download = file.name
      link.href = file.url
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setTimeout(() => {
        this.$set(this.downloadIds, fileId, false)
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.files {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: block;
    margin: 10px;
    // flex: 0 0 23%;
    width: 200px;
  }

  .image {
    width: 100%;
  }
}
.another {
  color: white;
  display: block;
  width: 100%;

  img {
    width: 100%;
  }
  .description {
    position: relative;
    width: 100%;
    text-align: center;
    .detail {
      top: 0;
      left: 0;
      position: absolute;
      display: flex;
      overflow: hidden;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      width: 100%;
    }
    .image {
    }
    .name {
      width: 100%;
      padding: 10px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 12px;
    }
    i.fa {
      font-size: 26px;
      color: #fff;
    }
    i.fa.spin {
      font-size: 26px;
      color: #fff;
    }
  }
}
@media only screen and (max-width: 600px) {
  .another {
    .description {
      i.fa {
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FFile.vue